import { render, staticRenderFns } from "./MemberDialog.vue?vue&type=template&id=1d13dccc&scoped=true&"
import script from "./MemberDialog.vue?vue&type=script&lang=js&"
export * from "./MemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13dccc",
  null
  
)

export default component.exports